/**
 * Shared list of sensitive key names used to redact values from structured logs
 * and Sentry events. The single source of truth across the codebase; each
 * consumer applies its own matching strategy, documented where it lives.
 *
 * List every exact key name that can carry a secret, derived names included:
 * the pino logger matches keys exactly, so a name it does not hold is logged
 * in plaintext. Only the Sentry scrubber matches by substring.
 *
 * A key whose value reaches a log as part of a longer string — a token in a URL
 * path, or a value interpolated into a message — is beyond what any entry here
 * can reach.
 *
 * Lives here (rather than in the logger package) so browser and React Native
 * apps can consume it without pulling Node-only logging dependencies into their
 * bundles.
 */
export const REDACTED_TERMS = [
  'password',
  'confirmPassword',
  'currentPassword',
  'newPassword',
  'token',
  'accessToken',
  'refreshToken',
  'idToken',
  'googleIdToken',
  'loginToken',
  'previewToken',
  'clientSecret',
  'codeVerifier',
  'secret',
  'sentDocumentHtml',
  'authorization',
  'cookie',
  'apiKey',
];
